import { FlexyHeaderForm, Modalizer } from '@europrocurement/flexy-components';
import { Box, Button, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { DossierValidator, dossierValidatorsSelector } from '@europrocurement/l2d-domain';
import { useSelector } from 'react-redux';
import { CheckboxListItem, VALIDATOR_TYPE_GREFFE } from '@europrocurement/l2d-modules';

type ValidatorsModalProps = {
    isOpen: boolean;
    onModalClose: () => void;
    onSubmitModal: (selectedItems: number[]) => void;
    itemsSelected: number[];
};

type ValidatorItem = {
    id: number;
    label: string;
    type: number;
    checked: boolean;
};

const ValidatorsModal: React.FunctionComponent<ValidatorsModalProps> = function (props) {
    const { isOpen, onModalClose, onSubmitModal, itemsSelected } = props;
    const [selectedItems, setSelectedItems] = useState(itemsSelected);
    const [searchTerm, setSearchTerm] = useState('');
    const dataSource = useSelector(dossierValidatorsSelector);

    const validatorsItems = dataSource.data
        .map((item: DossierValidator) => ({
            id: item.id as unknown as number,
            label: item.label,
            type: item.typeId as unknown as number,
            checked: selectedItems.indexOf(item.id as unknown as number) !== -1,
        }))
        .filter(
            (item: ValidatorItem) =>
                item.type === VALIDATOR_TYPE_GREFFE &&
                (!searchTerm || item.label.toLowerCase().match(searchTerm.toLowerCase())),
        )
        .sort((a: ValidatorItem, b: ValidatorItem) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) {
                return -1;
            }

            if (a.label.toLowerCase() > b.label.toLowerCase()) {
                return 1;
            }

            return 0;
        });
    const onCheckItem = (validatorId: number) => {
        if (selectedItems.indexOf(validatorId) === -1) {
            const tmpArray = [...selectedItems];
            tmpArray.push(validatorId);
            setSelectedItems(tmpArray);
        }
    };
    const onUncheckItem = (validatorId: number) => {
        if (selectedItems.indexOf(validatorId) !== -1) {
            const tmpArray = [...selectedItems];
            tmpArray.splice(tmpArray.indexOf(validatorId), 1);
            setSelectedItems(tmpArray);
        }
    };
    const cancelModal = () => {
        onModalClose();
    };
    const submitModal = () => {
        setSelectedItems(selectedItems);
        onSubmitModal(selectedItems);
    };

    useEffect(() => {
        setSelectedItems(itemsSelected);
    }, [isOpen, itemsSelected]);

    const items = validatorsItems.map((item: ValidatorItem) => (
        <Grid
            key={item.id}
            item
            style={{ width: '100%' }}
        >
            <CheckboxListItem
                label={item.label}
                checked={item.checked}
                onUpdate={(isChecked: boolean) => {
                    if (isChecked) {
                        onCheckItem(item.id);
                    } else {
                        onUncheckItem(item.id);
                    }
                }}
            />
        </Grid>
    ));

    const submitBtn = (
        <Button
            key="dossier-validator-submit_button"
            color="primary"
            variant="contained"
            onClick={submitModal}
            style={{ marginTop: '8px', marginBottom: '8px' }}
        >
            Confirmer
        </Button>
    );
    const cancelBtn = (
        <Button
            key="dossier-validator-cancelbutton"
            color="primary"
            variant="outlined"
            onClick={cancelModal}
            style={{ marginTop: '8px', marginBottom: '8px' }}
        >
            Annuler
        </Button>
    );

    return (
        <Modalizer
            open={isOpen}
            onClose={cancelModal}
            maxWidth="lg"
            fullWidth
            modalActions={[cancelBtn, submitBtn]}
        >
            <Box>
                <FlexyHeaderForm
                    outlined
                    label="Modifier les valideurs associés à cette formalité"
                />
                <TextField
                    fullWidth
                    placeholder="Filtrer la liste des formes juridiques"
                    sx={{ marginTop: '25px' }}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                    }}
                />
                <Box sx={{ marginTop: '25px', maxHeight: '60vh', overflowY: 'scroll' }}>
                    <Grid
                        container
                        gap="10px 0"
                    >
                        {items}
                    </Grid>
                </Box>
            </Box>
        </Modalizer>
    );
};

export default ValidatorsModal;
